import {
	ButtonBase,
	LinearProgress,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { ChevronRight, Trophy } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import {
	GOAL_CATEGORY_CONFIG,
	type Goal,
} from "web_myplann/Goals/Types/GoalTypes";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	goal: Goal;
};

export const CompletedGoalListItem: FC<Props> = ({ goal }) => {
	const theme = useTheme();
	const formatAmount = useFormatGoalAmount();
	const { t } = useResource();
	const CategoryIcon = GOAL_CATEGORY_CONFIG[goal.category].icon;

	const navigate = useNavigate();

	const handleGoalClick = (goalId: string) => {
		navigate(Routing.Goals.GoalDetail.path(goalId));
	};

	return (
		<ButtonBase
			onClick={() => handleGoalClick(goal.id)}
			sx={{ width: "100%", textAlign: "left" }}
		>
			<Stack
				direction="row"
				alignItems="center"
				gap={1.2}
				px={1.6}
				py={1.2}
				width="100%"
			>
				<IconBox bg={theme.palette.grey[100]} shape="circle">
					<CategoryIcon size={20} color={theme.palette.grey[400]} />
				</IconBox>

				<Stack flex={1} minWidth={0}>
					<Typography variant="bodyMedium" color={theme.palette.grey[500]}>
						{goal.name}
					</Typography>
					<LinearProgress
						variant="determinate"
						slim
						value={100}
						sx={{
							mb: 0.4,
							mt: 0.4,
							"& .MuiLinearProgress-bar": {
								bgcolor: theme.palette.grey[300],
							},
						}}
					/>
					<Typography variant="hint">
						{formatAmount(goal.totalValue)}{" "}
						{t(Resources.Goals.Amount.currencySign)}
					</Typography>
				</Stack>

				<Trophy size={16} color={theme.palette.warning.main} />
				<ChevronRight size={16} color={theme.palette.grey[300]} />
			</Stack>
		</ButtonBase>
	);
};
